import React from 'react';
import { useDispatch } from 'react-redux';
import { Form, Formik, useField } from 'formik';

import SquareModal from '../_composedBlocks/SquareModal';

import { authUserOperations } from '@evdy/web-redux/dist/lib/authUser';

import whiteChevron from '../../../public/images/icons/white-chevron-right.svg';

import styles from './EditPackageModal.module.scss';

const { updateUserPackageInfo } = authUserOperations;

const {
  'edit-package-modal-body': editPackageModalBodyClass,
  'edit-plan-container': editPlanContainerClass,
  'edit-package-container': editPackageContainerClass,
  'update-button': updateButtonClass,
  'cancel-button': cancelButtonClass,
  radio: radioBtnClass
} = styles;

const RadioOption = ({ color, customClass, fieldName, inputValue, radioLabel, isChecked }) => {
  const [field, , { setValue }] = useField(fieldName);

  return (
    <label
      htmlFor={radioLabel}
      onClick={() => setValue(inputValue)}
      className={`${customClass} ${radioBtnClass}`}
    >
      <input {...field} type="radio" name={fieldName} value={inputValue} checked={isChecked} />
      <p>{radioLabel}</p>
    </label>
  );
};

const EditPackageModal = ({ closeModal, modalVisible, packageInfo = [], userData }) => {
  const dispatch = useDispatch();
  const userPreneedData = userData?.preneed ?? {};
  // prefill form with user.preneed data if available
  const initialValues = {
    packageId: userPreneedData?.packageId || '',
    plan: userPreneedData?.plan?.planType || ''
  };

  const handleSubmit = values => dispatch(updateUserPackageInfo({ ...values }));

  const renderPackageOptions = ({ values }) =>
    packageInfo.map(pkg => {
      const { colors: { color1: color } = {}, name: packageName, packageId } = pkg;
      const isChecked = packageId === values?.packageId;

      return (
        <RadioOption
          {...{ color, isChecked }}
          radioLabel={packageName}
          inputValue={packageId}
          fieldName="packageId"
          key={packageName}
        />
      );
    });

  return (
    <SquareModal closeOnOverlayClick {...{ closeModal, modalVisible }}>
      <Formik {...{ initialValues }} onSubmit={handleSubmit} validateOnMount enableReinitialize>
        {({ values }) => (
          <Form>
            <div className={editPackageModalBodyClass}>
              <h3>Edit your plan</h3>
              <div className={editPlanContainerClass}>
                <RadioOption
                  inputValue="outright"
                  radioLabel="Buy Outright"
                  fieldName="plan"
                  isChecked={values?.plan === 'outright'}
                />
                <RadioOption
                  inputValue="insurance"
                  radioLabel="Buy Insurance Plan"
                  fieldName="plan"
                  isChecked={values?.plan === 'insurance'}
                />
              </div>
              <h3>Edit your package</h3>
              <div className={editPackageContainerClass}>{renderPackageOptions({ values })}</div>
              <button type="submit" className={updateButtonClass}>
                Update <img src={whiteChevron} alt="update" />
              </button>
              <button type="button" onClick={closeModal} className={cancelButtonClass}>
                Cancel
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </SquareModal>
  );
};

export default EditPackageModal;
